var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNoWorksData),expression:"showNoWorksData"}],staticClass:"ui-no-works"},[_c('div',{staticClass:"bg"}),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.noDataText))])])}
var staticRenderFns = []

export { render, staticRenderFns }